import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage1 from '../../../../assets/images/work/vale-hrp/Vale HRP_Slider.jpg';
import projectImage2 from '../../../../assets/images/work/vale-hrp/Vale HRP_Slider_2.jpg';
import projectImage3 from '../../../../assets/images/work/vale-hrp/Vale HRP_Slider_3.jpg';
import projectImage4 from '../../../../assets/images/work/vale-hrp/Vale HRP_Slider_4.jpg';
import projectImage5 from '../../../../assets/images/work/vale-hrp/Vale HRP_Slider_5.jpg';
import projectImage6 from '../../../../assets/images/work/vale-hrp/Vale HRP_Slider_6.jpg';

import Data_ValeHRP from './Data-ValeHRP';

function Work_ValeHRP() {
    return (
        <>
            <DetailedHeader
                heading="Preparing Workers for What Lies Below"
                client="Vale Canada"
                service="Virtual Reality"
                date="2024-Present"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                images={[
                    {
                        image: projectImage1,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage2,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage3,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage4,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage5,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage6,
                        alt: 'Project Image',
                    },
                ]}
            />

            {Data_ValeHRP.content}
        </>
    );
}

export default Work_ValeHRP;
